import { DocumentPage } from "../../components/layout/DocumentPage";
import { PageHeader } from "../../components/layout/PageHeader";
import { Reveal } from "../../components/motion/Reveal";
import { skillGroups } from "../../data/skills";
import styles from "./Skills.module.css";

export function Skills() {
  return (
    <DocumentPage id="skills" pageNumber={3}>
      <PageHeader
        eyebrow="03 / CAPABILITIES"
        title={"서비스 전 영역을 설계하고 구현할 수 있습니다."}
        description={"서비스 목적과 운영 환경에 맞춰 프론트엔드, API, 데이터베이스, 모바일 기술을 선택하고 유지보수 가능한 구조로 구현합니다."}
        wideDescription
      />
      <div className={styles.list}>
        {skillGroups.map((group, index) => (
          <Reveal key={group.title} delay={index * 0.05} className={styles.row}>
            <span>{group.index}</span>
            <h3>{group.title}</h3>
            <p>{group.items.join(" · ")}</p>
          </Reveal>
        ))}
      </div>
    </DocumentPage>
  );
}
